import { getSericeHeaderBackgroundScrollProps } from "./block-utils";

(() => {
  class ServiceHeader {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.background = wrapper.querySelector(".luther-service-header__image");
      this.heading = wrapper.querySelector(".luther-service-header__title");
      this.mainContent = document.querySelector("body > .main-content");

      this._init();
    }

    _init() {
      this.wrapper.classList.add("initialized");
      this.mainContent.addEventListener(
        "scroll",
        this.onScroll.bind(this),
        true,
      );
    }

    onScroll() {
      const headerHeight = this.wrapper.offsetHeight || 0;
      const scrollPos = this.mainContent.scrollTop || 0;

      if (scrollPos > headerHeight) return;

      const { opacity, scale, rotateX, translateY } =
        getSericeHeaderBackgroundScrollProps(headerHeight, scrollPos);

      this.background.style.transform = `translateY(${translateY}px) scale(${scale}) perspective(10px) rotateX(${rotateX}deg)`;
      this.background.style.opacity = opacity;
      this.heading.style.transform = `translateY(${translateY / 1.25}px)`;
    }
  }

  window.luther = window.luther || {};
  window.luther.serviceHeaders = [];

  function updateLutherServiceHeadersInstances() {
    const newServiceHeaders = document.querySelectorAll(
      ".luther-service-header:not(.initialized)",
    );
    newServiceHeaders.forEach((el) => {
      window.luther.serviceHeaders.push(new ServiceHeader(el));
    });
  }

  document.addEventListener(
    "DOMContentLoaded",
    updateLutherServiceHeadersInstances,
  );

  window?.luther?.eventBus?.on(
    "luther:pageContentChange",
    updateLutherServiceHeadersInstances,
  );

  window?.luther?.eventBus?.on("luther:pageContentRemoved", () => {
    console.log("TODO Header Event Listener für Page Transition abbauen");
  });
})();
